import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-20 px-4" data-id="element-108">
      <div className="max-w-4xl mx-auto text-center" data-id="element-109">
        {/* Logo */}
        <div className="text-[#B87AFF] text-3xl font-black tracking-widest mb-8" data-id="element-110">
          🧘 EDULABS™
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-111">
          El próximo domingo puedes seguir buscando en internet.
        </h2>
        <p className="text-[#B87AFF] text-2xl sm:text-3xl font-black mb-10" data-id="element-112">
          O puedes tener todo resuelto desde hoy.
        </p>

        {/* Cost Table */}
        <div className="bg-[#1a0a2e] border border-[#B87AFF]/30 rounded-2xl overflow-hidden mb-12 max-w-2xl mx-auto text-left" data-id="element-113">
          <div className="p-4 bg-[#0d0a1a] border-b border-[#B87AFF]/30 text-center font-bold text-white" data-id="element-114">
            ¿Cuánto cuesta NO tenerlo?
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 bg-[#0d0a1a] border-b border-[#B87AFF]/30" data-id="element-115">
            <div className="p-4 font-bold text-gray-400 text-center" data-id="element-116">
              Sin MegaPack Yoga Listo
            </div>
            <div className="p-4 font-bold text-[#B87AFF] text-center sm:border-l border-[#B87AFF]/30" data-id="element-117">
              Con MegaPack Yoga Listo
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-118">
            <div className="p-4 text-gray-400 text-sm" data-id="element-119">
              120 hs/año planificando desde cero
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#B87AFF]/5 sm:border-l border-gray-800" data-id="element-120">
              10 min/semana. El resto es enseñar.
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-121">
            <div className="p-4 text-gray-400 text-sm" data-id="element-122">
              Correcciones improvisadas → mismo error por meses
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#B87AFF]/5 sm:border-l border-gray-800" data-id="element-123">
              120+ guiones exactos → se resuelve en la clase
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-124">
            <div className="p-4 text-gray-400 text-sm" data-id="element-125">
              70% de abandono antes del año
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#B87AFF]/5 sm:border-l border-gray-800" data-id="element-126">
              Sistema de retención → tasa +85%
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-127">
            <div className="p-4 text-gray-400 text-sm" data-id="element-128">
              Sin material diferenciado por nivel
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#B87AFF]/5 sm:border-l border-gray-800" data-id="element-129">
              6 tomos con progresión → avanzan y recomiendan
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-130">
            <div className="p-4 text-gray-400 text-sm" data-id="element-131">
              Savasana siempre igual y sin profundidad
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#B87AFF]/5 sm:border-l border-gray-800" data-id="element-132">
              60 guiones de meditación → la parte más esperada de la clase
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-133">
            <div className="p-4 text-gray-400 text-sm" data-id="element-134">
              Talleres organizados sin sistema ni rentabilidad
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#B87AFF]/5 sm:border-l border-gray-800" data-id="element-135">
              8 tipos de taller + calculadora + cronograma exacto
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-136">
            <div className="p-4 text-gray-400 text-sm" data-id="element-137">
              Sin identidad visual profesional
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#B87AFF]/5 sm:border-l border-gray-800" data-id="element-138">
              Identidad premium que justifica cobrar más
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-139">
            <div className="p-4 text-gray-400 text-sm" data-id="element-140">
              Contratos verbales que terminan en conflicto
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#B87AFF]/5 sm:border-l border-gray-800" data-id="element-141">
              Kit completo de documentos legales firmados
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-142">
            <div className="p-4 text-gray-400 text-sm" data-id="element-143">
              Alumnos que no saben cuándo suben de nivel
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#B87AFF]/5 sm:border-l border-gray-800" data-id="element-144">
              Sistema de evaluación → el alumno ve su progreso solo
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-145">
            <div className="p-4 text-gray-400 text-sm" data-id="element-146">
              Inversiones sin protocolo
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#B87AFF]/5 sm:border-l border-gray-800" data-id="element-147">
              Protocolo de 6 etapas → ninguna lesión por apuro
            </div>
          </div>
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-148">
          <p className="text-white font-bold mb-4" data-id="element-149">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-150" />
        </div>

        {/* 2 mini pricing cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 max-w-2xl mx-auto" data-id="element-151">
          <div className="bg-[#0a0a0a] border border-[#B87AFF]/30 rounded-xl p-6 text-center flex flex-col" data-id="element-152">
            <div className="text-2xl mb-2" data-id="element-153">📘</div>
            <h3 className="text-white font-black mb-1" data-id="element-154">MEGAPACK YOGA LISTO</h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-155">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-156">
              <p className="text-gray-400 line-through text-sm mb-1" data-id="element-157">
                Antes: $24.90 USD
              </p>
              <p className="text-[#B87AFF] text-2xl font-black mb-4" data-id="element-158">
                Hoy: $13.90 USD
              </p>
              <a href="https://docentes2.edulabs.online/cart/43234796503158:1" className="btn-green-pulse block bg-[#B87AFF] font-black py-4 rounded-lg hover:bg-[#D4A5FF] transition-colors text-sm text-[#FFFFFF]" data-id="element-159">
                → QUIERO MI MEGAPACK
              </a>
              <p className="text-gray-400 text-xs mt-3 italic" data-id="element-160">
                💬 El cobro se realizará en la moneda de tu país al tipo de
                cambio vigente. Aceptamos tarjeta de crédito/débito local,
                PayPal y transferencia bancaria.
              </p>
            </div>
          </div>

          <div className="bg-[#0d0a1a] border-2 border-[#B87AFF] rounded-xl p-6 text-center shadow-[0_0_30px_rgba(184,122,255,0.2)] flex flex-col" data-id="element-161">
            <div className="text-2xl mb-2" data-id="element-162">🏆</div>
            <h3 className="text-[#B87AFF] font-black mb-1" data-id="element-163">
              MEGAPACK + ESTUDIO PRO ELITE™ ⭐
            </h3>
            <p className="text-gray-400 text-xs mb-1" data-id="element-164">La más elegida</p>
            <p className="text-gray-400 text-xs mb-4" data-id="element-165">
              6 Tomos + 6 Bonos + Estudio Pro Elite™
              <br data-id="element-166" />
              (gestión, marketing, precios y negocio)
            </p>
            <div className="mt-auto" data-id="element-167">
              <p className="text-gray-400 line-through text-sm mb-1" data-id="element-168">
                Antes: $31.90 USD
              </p>
              <p className="text-[#B87AFF] text-3xl font-black mb-4" data-id="element-169">
                Hoy: $19.90 USD
              </p>
              <a href="https://docentes2.edulabs.online/cart/43234778906742:1" className="btn-green-pulse block bg-[#B87AFF] font-black py-4 rounded-lg hover:bg-[#D4A5FF] transition-colors text-sm text-[#FFFFFF]" data-id="element-170">
                → QUIERO EL MEGAPACK + ESTUDIO PRO ELITE
              </a>
              <p className="text-gray-400 text-xs mt-3 italic" data-id="element-171">
                💬 El cobro se realizará en la moneda de tu país al tipo de
                cambio vigente. Aceptamos tarjeta de crédito/débito local,
                PayPal y transferencia bancaria.
              </p>
            </div>
          </div>
        </div>

        {/* Final trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300" data-id="element-172">
          <span data-id="element-173">🔒 Pago 100% seguro</span>
          <span data-id="element-174">⚡ Acceso en 5 minutos</span>
          <span data-id="element-175">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-176">💳 Tarjeta de crédito | PayPal | Transferencia bancaria</span>
        </div>
      </div>
    </section>;
}